import { ColumnDefWithTooltip } from "src/components/Table/Table";
import type { OrganizationError } from "src/hooks/useOrganization";
import { formatIsoDateToOrgDate } from "src/services/format";
import type * as GQL from "src/types/graphql";
import type { RemoteData } from "src/types/remoteData";
import { ColumnId } from "./constants";

type Row = {
  form: { submittedAt: timestamptz | null } | null;
};

export function buildSubmittedDateColumnDef<T extends Row>({
  organization,
}: {
  organization: RemoteData<OrganizationError, GQL.Organization>;
}): ColumnDefWithTooltip<T> {
  return {
    id: ColumnId.SubmittedDate,
    header: "Submitted Date",
    cell: (props) =>
      formatIsoDateToOrgDate(
        props.row.original.form?.submittedAt ?? null,
        organization
      ),
  };
}
